import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

import type { ProductOffer } from 'v2/interfaces/product';

import type { UseQueryOptions } from '@tanstack/react-query';

type Payload = {
  productId: number;
  orderByNameAsc?: boolean;
  trashed?: boolean;
};

export function useProductOffers({ productId, orderByNameAsc, trashed }: Payload, options: UseQueryOptions<ProductOffer[]> = {}) {
  return useQuery({
    queryKey: ['products', productId, 'offers', { orderByNameAsc, trashed }],
    queryFn: () => productService.getOffers(productId, { order_by_name_asc: orderByNameAsc, trashed }),
    ...options,
  });
}
